"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAccess = void 0;
var rules_1 = require("../rules");
var helpers_1 = require("./helpers");
var react_redux_1 = require("react-redux");
/**
 * React hook that determines if a user has access to a given rule
 *
 * @param rule the rule to check
 * @returns true if the user should be granted access, else false
 */
var useAccess = function (rule) {
    var _a = (0, react_redux_1.useSelector)(function (state) {
        var _a, _b;
        return ({
            entitlement: state.businessUnit.availableFeatures,
            modules: state.businessUnit.businessModules,
            launchDarkly: state.launchDarkly,
            userRole: (_b = (_a = state.businessUnit.access) === null || _a === void 0 ? void 0 : _a.role) === null || _b === void 0 ? void 0 : _b.name,
        });
    }), entitlement = _a.entitlement, modules = _a.modules, launchDarkly = _a.launchDarkly, userRole = _a.userRole;
    return (0, helpers_1.hasAccess)(rules_1.rules, rule, entitlement, modules.map(function (module) { return module.name; }), launchDarkly, userRole);
};
exports.useAccess = useAccess;
//# sourceMappingURL=hooks.js.map